import { render, staticRenderFns } from "./SingleScreen.vue?vue&type=template&id=03331b16&scoped=true"
import script from "./SingleScreen.vue?vue&type=script&lang=js"
export * from "./SingleScreen.vue?vue&type=script&lang=js"
import style0 from "./SingleScreen.vue?vue&type=style&index=0&id=03331b16&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03331b16",
  null
  
)

export default component.exports